<template>
    <div class="purchase-course artist-session">
        <template v-if="buttonOnly">
            <template v-if="session.isUserPreRegistered">
                <div class="text-white mt-1 pt-2 intercom-pushin">You have already registered your interest in this session.</div>
            </template>
            <template v-else>
                <b-button variant="primary" class="btn-slimpad btn-block btn-white btn-register-interest intercom-pushin" @click="registerClick">Register interest</b-button>
            </template>
        </template>
        <template v-else>
            
            <template v-if="session.isUserPreRegistered">
                <div class="mt-3">
                    <h3 class="notif mb-0">You have already registered your interest in this session.</h3>
                </div>
            </template>
            <template v-else>

                <div class="row justify-content-center">
                    <div class="col-md-10">
                        <div class="block left">
                            <div class="row">
                                <div class="col-12 col-lg-8">                                
                                    <h3>
                                        Want to take part?
                                    </h3>
                                    <ul class="list-unstyled">
                                        <li>Pre-register now to be first to know when tickets go on sale.</li>
                                    </ul>
                                </div>
                                <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                    <div class="meta-info">
                                        <b-button variant="primary" class="btn-slimpad btn-block btn-white" @click="registerClick">Register interest</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>

         <b-modal ref="registerModal" :title="'Pre-register for ' + session.name" :ok-only="true" ok-variant="link" ok-title="Close">
            <template v-if="isAuth && isVerified">
                <template v-if="isSuccess">
                    Thanks! You have registered your interest in this session. We will be in touch when this session is going on sale.
                </template>
                <template v-else>
                    <template v-if="isBusy">
                        Please wait...
                    </template>
                    <template v-else>
                        <b-alert variant="danger" :show="hasError" class="mb-2">{{ error }}</b-alert>
                        <b-button variant="success" @click="beginPreReg">Register interest</b-button>
                    </template>
                </template>
            </template>
            <template v-else-if="isAuth && !isVerified">
                <p>
                    Thanks for signing up. We have sent you an email to verify your email address.
                </p>
                <p>
                    Click the link in your email to verify your email address and then you can pre-reigster for this session.
                </p>
            </template>
            <template v-else>
                <p>
                    We just need a name, email and password.
                    You'll use your free account with us to take part in the session.
                </p>
                <auth-basic-component :session="session" :return="session.uri"></auth-basic-component>
            </template>
        </b-modal>

         <b-modal ref="verifyModal" size="lg" title="Verify your email address" :ok-only="true" ok-variant="link" ok-title="Close">
            <p>
                Thanks for signing up. We have sent you an email to verify your email address.
            </p>
            <p>
                Click the link in your email to verify your email address and then you can enrol on this session.
            </p>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            session: {
                type: Object,
                required: true,
            },
            buttonOnly: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                isAuth: false,
                user: {},
                isVerified: false,
                isNewUser: false,
                isBusy: false,
                hasError: false,
                error: '',
                isSuccess: false,
            }
        },

        mounted() {
            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                    this.isVerified = window.virtuoso.is_verified;
                }
            }
            
            // Pre registration has begun
            Bus.$on("preRegisterBusy", (d) => {
                this.isBusy = true;
                this.hasError = false;
                this.error = '';
            });
            
            // Pre registration successful
            Bus.$on("preRegisterSuccess", (d) => {
                this.isAuth = true;
                this.isSuccess = true;
            });
            
            // Pre registration failed
            Bus.$on("preRegisterError", (d) => {
                this.hasError = true;
                this.error = d;
                this.isBusy = false;
            });
            
            // When payment methods have been updated refresh that section
            Bus.$on("userRegistered", (d) => {
                this.isAuth = true;
                this.user = d;
                this.isNewUser = true;
            });
        },

        methods: {
            // Clicked to apply for a seat
            registerClick() {
                this.$refs['registerModal'].show('registerModal');

                // Fire it immediately to stop using having to click again
                if(this.isAuth && !this.isNewUser) {
                    this.beginPreReg();
                }
            },

            // Fires an event picked up by the handler component
            beginPreReg() {
                Bus.$emit('firePreRegister', this.user);
            },
        }
    }
</script>